export default "__VITE_ASSET__731f6072__"